import React from 'react';
import './style.scss';
import { IContentSection, ITableOfContentItem } from '../page-template';
import PageTemplate from '../page-template/component';
import HeaderImg from '../../../assets/images/travbusiness-template-pages/common-banner-bg-BMBchR2h.jpg'
import { useIntl } from 'react-intl';

const TravBusinessFaqPage: React.FC = () => {
  const intl = useIntl();
  
  const tocItems: ITableOfContentItem[] = [
    { id: 'general-questions', title: intl.formatMessage({ id: 'faq.general-questions.title' }) },
    { id: 'booking-information', title: intl.formatMessage({ id: 'faq.booking-information.title' }) },
    { id: 'payment-and-billing', title: intl.formatMessage({ id: 'faq.payment-and-billing.title' }) },
    { id: 'cancellation-and-changes', title: intl.formatMessage({ id: 'faq.cancellation-and-changes.title' }) },
    { id: 'travel-insurance', title: intl.formatMessage({ id: 'faq.travel-insurance.title' }) },
    { id: 'technical-support', title: intl.formatMessage({ id: 'faq.technical-support.title' }) },
    { id: 'membership-benefits', title: intl.formatMessage({ id: 'faq.membership-benefits.title' }) },
    { id: 'contact-information', title: intl.formatMessage({ id: 'faq.contact-information.title' }) },
  ];

  const sections: IContentSection[] = [
    {
      id: 'general-questions',
      title: intl.formatMessage({ id: 'faq.general-questions.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'faq.general-questions.paragraph.1' }),
        intl.formatMessage({ id: 'faq.general-questions.paragraph.2' }),
        intl.formatMessage({ id: 'faq.general-questions.paragraph.3' }),
      ],
    },
    {
      id: 'booking-information',
      title: intl.formatMessage({ id: 'faq.booking-information.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'faq.booking-information.paragraph.1' }),
        intl.formatMessage({ id: 'faq.booking-information.paragraph.2' }),
        intl.formatMessage({ id: 'faq.booking-information.paragraph.3' }),
      ],
    },
    {
      id: 'payment-and-billing',
      title: intl.formatMessage({ id: 'faq.payment-and-billing.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'faq.payment-and-billing.paragraph.1' }),
        intl.formatMessage({ id: 'faq.payment-and-billing.paragraph.2' }),
        intl.formatMessage({ id: 'faq.payment-and-billing.paragraph.3' }),
      ],
    },
    {
      id: 'cancellation-and-changes',
      title: intl.formatMessage({ id: 'faq.cancellation-and-changes.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'faq.cancellation-and-changes.paragraph.1' }),
        intl.formatMessage({ id: 'faq.cancellation-and-changes.paragraph.2' }),
      ],
    },
    {
      id: 'travel-insurance',
      title: intl.formatMessage({ id: 'faq.travel-insurance.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'faq.travel-insurance.paragraph.1' }),
        intl.formatMessage({ id: 'faq.travel-insurance.paragraph.2' }),
      ],
    },
    {
      id: 'technical-support',
      title: intl.formatMessage({ id: 'faq.technical-support.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'faq.technical-support.paragraph.1' }),
        intl.formatMessage({ id: 'faq.technical-support.paragraph.2' }),
      ],
    },
    {
      id: 'membership-benefits',
      title: intl.formatMessage({ id: 'faq.membership-benefits.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'faq.membership-benefits.paragraph.1' }),
        intl.formatMessage({ id: 'faq.membership-benefits.paragraph.2' }),
      ],
    },
    {
      id: 'contact-information',
      title: intl.formatMessage({ id: 'faq.contact-information.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'faq.contact-information.paragraph.1' }),
        intl.formatMessage({ id: 'faq.contact-information.paragraph.2' }),
      ],
    },
  ];

  return (
    <div className="weeks-results-page">
      <PageTemplate
        headerImage={HeaderImg}
        headerTitle={intl.formatMessage({ id: 'faq.headerTitle' })}
        headerSubtitle={intl.formatMessage({ id: 'faq.headerSubtitle' })}
        tableOfContents={tocItems}
        contentSections={sections}
        positionHeaderImg='center'
      />
    </div>
  );
};

export default TravBusinessFaqPage;
